export const TSHIRT_SIZES = ['XS', 'S', 'M', 'L', 'XL'];
/**
 * The one-hour minimum. Every estimate, every actual, every invoice line goes through
 * `applyMinimum` — this constant is the only place the number exists, so it cannot be
 * one value on the sizing form and another on the billing screen.
 */
export const MINIMUM_BILLABLE_HOURS = 1;
/** Why the floor exists. Kept separate so the notice below can be reworded without losing it. */
export const MINIMUM_HOURS_RATIONALE = 'covers the verification, testing, and stability work that every change carries beyond the edit itself';
/** The sentence the UI shows wherever an estimate appears. Interpolated, never retyped. */
export const MINIMUM_HOURS_NOTICE = `Every request is billed at a ${MINIMUM_BILLABLE_HOURS}-hour minimum, which ${MINIMUM_HOURS_RATIONALE}.`;
/** Starting points for a human estimate, not a tariff. Each is overridable per issue. */
export const SIZE_DEFAULT_HOURS = {
    XS: 1,
    S: 2,
    M: 4,
    L: 8,
    XL: 16,
};
/**
 * Raise anything below the floor to the floor.
 *
 * Non-finite input returns the minimum rather than propagating NaN: `Number(null)` and
 * `Number('')` are 0, and a numeric column arriving as NULL is an ordinary occurrence, so
 * the failure mode to design against is an hours field that quietly bills zero.
 */
export function applyMinimum(hours) {
    if (!Number.isFinite(hours))
        return MINIMUM_BILLABLE_HOURS;
    return Math.max(hours, MINIMUM_BILLABLE_HOURS);
}
/** Default estimate for a size, already floored. */
export function defaultHoursForSize(size) {
    return applyMinimum(SIZE_DEFAULT_HOURS[size]);
}
const round2 = (n) => Math.round(n * 100) / 100;
/** Compare an estimate against actuals, both measured after the one-hour minimum. */
export function estimateVariance(estimatedHours, actualHours) {
    const estimated = applyMinimum(estimatedHours);
    const actual = applyMinimum(actualHours);
    const deltaHours = round2(actual - estimated);
    return {
        estimatedHours: estimated,
        actualHours: actual,
        deltaHours,
        ratio: round2(actual / estimated),
        direction: deltaHours > 0 ? 'over' : deltaHours < 0 ? 'under' : 'on_target',
        absorbedByMinimum: Number.isFinite(actualHours) && actualHours < MINIMUM_BILLABLE_HOURS,
    };
}
//# sourceMappingURL=estimation.js.map